import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import favicon from '../img/favicon.ico'

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="Stellar"
      link={[{ rel: 'shortcut icon', type: 'image/png', href: `${favicon}` }]}
    >
      <meta
        name="viewport"
        content="initial-scale=1, maximum-scale=1.0, user-scalable=0, viewport-fit=cover"
      />
      <meta
        name="description"
        content="Stellar is an open network for sending and exchanging any kind of value"
      />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@stellarorg" />
      <meta name="twitter:title" content="What is Stellar?" />
      <meta
        name="twitter:description"
        content="Stellar is an open network for sending and exchanging any kind of value"
      />
      <meta
        name="twitter:image"
        content="https://learn.stellar.org/twitter-card-1024.png"
      />
      <meta property="og:url" content="https://learn.stellar.org" />
      <meta property="og:title" content="What is Stellar?" />
      <meta
        property="og:description"
        content="Stellar is an open network for sending and exchanging any kind of value"
      />
      <meta
        property="og:image"
        content="https://learn.stellar.org/facebook-1200.png"
      />
    </Helmet>
    {children()}
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js